module.exports = "<table border=\"0\" cellpadding=\"0\" cellspacing=\"0\" width=\"475\" height=\"100%\">\n\t<tr>\n\t\t<td align=\"center\"><a href=\"assets/images/card_layout.png\" target=\"_blank\">\n\t\t<img src=\"assets/images/card_real.gif\" border=\"0\"></a> </td>\n\t</tr>\n</table>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/cards.component.html
// module id = 158
// module chunks = 1